import React from "react";
import { motion } from "framer-motion";
import useAnimationSettings from "../../hooks/useAnimationSettings";

const VIOLETA = "#697B68";
const ROSA = "#E09767";

const RESPONSIBILITIES = [
  "Gestiono, planifico y priorizo planes de desarrollo, coordinando tareas y su ejecución",
  "Desarrollo y despliego aplicaciones Full Stack orientadas a los objetivos del negocio",
  "Implemento IA con OpenAI, Google Gemini y modelos locales según las necesidades de cada proyecto",
  "Diseño e implemento automatizaciones con n8n para optimizar flujos de trabajo",
  "Lidero al equipo de desarrollo y alineo su trabajo con los objetivos del negocio",
  "Capacito al equipo interno y a los clientes en los sistemas desarrollados",
];

export default function CurrentRole() {
  const { reduceMotion, durations, offsets, viewport } = useAnimationSettings();

  return (
    <section className="portfolio-section w-full bg-[#F8F2EA]">
      <div className="mx-auto max-w-7xl">
        <motion.div
          initial={reduceMotion ? false : { opacity: 0, y: offsets.revealY }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={viewport}
          transition={{ duration: reduceMotion ? 0 : durations.reveal, ease: "easeOut" }}
          className="mb-9 text-center md:mb-12"
        >
          <h3
            className="section-title tracking-tight"
            style={{ color: VIOLETA }}
          >
            Rol actual
          </h3>
          <div
            className="mx-auto mt-3 h-[3px] w-24 rounded-full"
            style={{
              background: `linear-gradient(135deg, ${ROSA}, ${VIOLETA})`,
            }}
          />
        </motion.div>

        <motion.div
          initial={reduceMotion ? false : { opacity: 0, y: offsets.revealY + 4 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={viewport}
          transition={{ duration: reduceMotion ? 0 : durations.reveal, ease: "easeOut" }}
          className="grid gap-8 lg:grid-cols-[0.95fr,1.05fr]"
        >
          <div
            className="card-padding min-w-0 rounded-2xl border bg-white/90 shadow-md sm:rounded-[2rem] sm:shadow-xl"
            style={{
              borderColor: `${VIOLETA}1A`,
              boxShadow: "0 20px 45px -20px rgba(105,123,104,0.25)",
            }}
          >
            <div
              className="mb-4 inline-flex items-center gap-2 rounded-full px-4 py-2 text-xs font-bold uppercase tracking-wider"
              style={{
                backgroundColor: `${ROSA}14`,
                color: ROSA,
              }}
            >
              Further Corporate
            </div>

            <h4
              className="card-title"
              style={{ color: VIOLETA }}
            >
              Responsable del área · AI Strategist & Full Stack Developer
            </h4>

            <p
              className="body-copy mt-5"
              style={{ color: `${VIOLETA}CC` }}
            >
              En Further Corporate gestiono, planifico y priorizo los planes de desarrollo. Coordino las tareas y lidero al equipo para alinear la ejecución técnica con los objetivos del negocio.
            </p>

            <p
              className="body-copy mt-5 hidden sm:block"
              style={{ color: `${VIOLETA}B3` }}
            >
              Desarrollo y despliego aplicaciones Full Stack, implemento inteligencia artificial con OpenAI, Google Gemini y modelos locales, y diseño automatizaciones con n8n. También capacito al equipo interno y a los clientes en los sistemas desarrollados.
            </p>
          </div>

          <div
            className="card-padding min-w-0 rounded-2xl border bg-white/90 shadow-md sm:rounded-[2rem] sm:shadow-xl"
            style={{
              borderColor: `${VIOLETA}1A`,
              boxShadow: "0 20px 45px -20px rgba(105,123,104,0.25)",
            }}
          >
            <h4
              className="card-title"
              style={{ color: VIOLETA }}
            >
              Dónde aporto valor
            </h4>

            <ul className="mt-6 grid gap-4">
              {RESPONSIBILITIES.map((item, index) => (
                <li key={item} className={`${index > 3 ? "hidden sm:flex" : "flex"} items-start gap-3 text-left`}>
                  <span
                    className="mt-2 h-2.5 w-2.5 flex-shrink-0 rounded-full"
                    style={{ backgroundColor: ROSA }}
                  />
                  <span
                    className="body-copy"
                    style={{ color: `${VIOLETA}CC` }}
                  >
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
